import { render, staticRenderFns } from "./Tray.vue?vue&type=template&id=7a5c1bec&scoped=true&"
import script from "./Tray.vue?vue&type=script&lang=ts&"
export * from "./Tray.vue?vue&type=script&lang=ts&"
import style0 from "./Tray.vue?vue&type=style&index=0&id=7a5c1bec&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5c1bec",
  null
  
)

export default component.exports